/**
 * Centralized RTK Query cache tag definitions.
 * Feature APIs inject endpoints and use these tags for invalidation.
 */
export const API_TAGS = {
  Auth: 'Auth',
  User: 'User',
  Users: 'Users',
  Dashboard: 'Dashboard',
  Notifications: 'Notifications',
  Settings: 'Settings',
  Reports: 'Reports',
  Branch: 'Branch',
  Bookings: 'Bookings',
  Forms: 'Forms',
  DataCollectionForms: 'DataCollectionForms',
  Customers: 'Customers',
  Promotions: 'Promotions',
  Tags: 'Tags',
  PublicRelations: 'PublicRelations',
  Collaborators: 'Collaborators',
  Landing: 'Landing',
  Amenities: 'Amenities',
  Events: 'Events',
  FormMenus: 'FormMenus',
  Rooms: 'Rooms',
  MessageDeliveryEvents: 'MessageDeliveryEvents',
  BulkMessages: 'BulkMessages',
  Fidelity: 'Fidelity',
  DiscountCards: 'DiscountCards',
  FidelityPrizes: 'FidelityPrizes',
  FidelityExperiences: 'FidelityExperiences',
  GiftCards: 'GiftCards',
  Menu: 'Menu',
  WhatsAppTemplates: 'WhatsAppTemplates',
  WhatsAppOfficial: 'WhatsAppOfficial',
  WhatsAppOnboarding: 'WhatsAppOnboarding',
  Messages: 'Messages',
  StripeAccount: 'StripeAccount',
  StripePayments: 'StripePayments',
  Communications: 'Communications',
  AppVersion: 'AppVersion',
} as const;

export type ApiTag = (typeof API_TAGS)[keyof typeof API_TAGS];

export const tagTypes = Object.values(API_TAGS);
